<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <b-button style="display: none" v-b-modal.modal-1 ref="gg"> </b-button>
    <component :is="layout">
      <router-view />
    </component>
    <!-- basic modal -->
    <b-modal id="modal-subscribe-ended" title="انتهى الإشتراك" hide-footer>
      <h2 class="text-center">
        <img
          :src="require('@/assets/images/sad.png')"
          style="width: 120px"
          alt=""
        />
        إنتهى إشتراكك!
        <br /><br />
        <button
          class="btn btn-relief-success"
          @click="
            closeModal();
            $router.push('/subscribe');
          "
        >
          اشتراك الآن
        </button>
      </h2>
      <br />
      <p class="text-center">
        سيتم تعطيل خدمات النظام لحين الاشتراك / تجديد الاشتراك.
      </p>
    </b-modal>
    <button
      class="dnone"
      id="c-subscribe-ended"
      v-b-modal.modal-subscribe-ended
    ></button>
  </div>
</template>

<script>
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from "@themeConfig";
import { provideToast } from "vue-toastification/composition";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { BModal, BButton, VBModal, BAlert, BCardText } from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import Ripple from "vue-ripple-directive";
import { useWindowSize, useCssVar } from "@vueuse/core";

import store from "@/store";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutHorizontal = () =>
  import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");

export default {
  data() {
    return {
      total: 0,
    };
  },
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
    BCardCode,
    BButton,
    BModal,
    BAlert,
    BCardText,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
  },
  beforeCreate() {
    var _g = this,
      g = this;
    var i = setInterval(() => {
      var user = localStorage.getItem("user");
      if (!user) {
        if (
          window.location.pathname != "/login" &&
          window.location.pathname != "/logout" &&
          window.location.pathname != "/error-404"
        ) {
          clearInterval(i);
          _g.$router.push("/login");
        }
      } else {
        clearInterval(i);
        $.post(api + "/user/auth/check", {
          jwt: JSON.parse(user).jwt,
        })
          .then(function (data) {
            if (data.status != 100 && data.status != 300) {
              _g.$router.push("/logout");
            } else {
              if (
                JSON.stringify(data.response) != localStorage.getItem("user")
              ) {
                location.reload();
              }
              if (
                new Date(data.response.subscribe.exdate).getTime() <
                new Date().getTime()
              ) {
                $("#c-subscribe-ended").click();
              }
              localStorage.setItem("user", JSON.stringify(data.response));
              // loggedin
              // end loggedin
            }
          })
          .catch(function () {
            _g.$router.push("/logout");
          });
      }
    }, 100);

    // Set colors in theme
    const colors = [
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
      "light",
      "dark",
    ];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement
      ).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      );
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();

    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: "Vue-Toastification__fade",
    });

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });

    return {
      skinClasses,
    };
  },
  methods: {
    closeModal() {
      $("#modal-subscribe-ended___BV_modal_header_ > button").click();
    },
  },
};
</script>
